<script>
export default {
  name: 'icon-edit',
  props: {
    color: {
      default: () => {
        return 'white'
      },
      type: String,
    },
  },
}
</script>

<template>
  <svg
    width="38"
    height="19"
    viewBox="0 0 38 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 3.5L19 15.5L35 3.5"
      stroke="#00A5EE"
      stroke-width="6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
